<div class="page-container">

  <!-- Header -->
  <div class="page-header">
    <div class="page-title-section">
      <mat-icon class="page-icon">credit_card</mat-icon>
      <div>
        <div class="page-title">Payment Processor</div>
        <div class="page-subtitle">Choose which processor takes payments and manage its credentials.</div>
      </div>
    </div>
  </div>

  <mat-tab-group>
    <mat-tab label="Configuration">
      <div class="tab-body">

        <mat-card class="error-panel" *ngIf="loadError">
          <mat-card-content>
            <mat-icon color="warn">error_outline</mat-icon>
            <span>{{ loadError }}</span>
          </mat-card-content>
        </mat-card>

        <ng-container *ngIf="!loadError">

          <div class="empty-state" *ngIf="!configs.length">
            No payment processor configurations found.
          </div>

          <ng-container *ngIf="configs.length">

            <mat-card class="live-now-card" *ngIf="liveConfig as live">
              <mat-card-content>
                <div class="live-now-label">Live now</div>
                <div class="live-now-status">
                  <span class="status-dot" [class.status-dot--live-money]="isLiveMoney(live)"></span>
                  <span class="live-now-title">{{ liveStatusTitle(live) }}</span>
                </div>
                <div class="live-now-subtitle">{{ liveStatusSubtitle(live) }}</div>
              </mat-card-content>
            </mat-card>

            <div class="processor-switch">
              <div class="processor-switch-label">Processor</div>
              <mat-button-toggle-group
                [value]="selectedConfigId"
                (change)="onSelectEnvironment($event)">
                <mat-button-toggle *ngFor="let config of configs" [value]="config.id">
                  {{ toggleLabel(config) }}
                </mat-button-toggle>
              </mat-button-toggle-group>
            </div>

            <ng-container *ngIf="selectedConfig as selected">
              <div class="detail-grid">
                <div class="detail-col">

                  <mat-card class="mock-explainer" *ngIf="selected.processor === 'MOCK'">
                    <mat-card-content>
                      Mock doesn't need any setup. It simulates payments, so there's nothing to configure.
                    </mat-card-content>
                    <mat-card-actions class="card-actions" *ngIf="selected.id !== activeConfigId">
                      <button mat-flat-button color="primary" (click)="onSwitchLive(selected)">
                        Switch payments to {{ environmentLabel(selected) }}
                      </button>
                    </mat-card-actions>
                  </mat-card>

                  <mat-card class="credentials-card"
                            *ngIf="selected.processor === 'CATALIS' && forms[selected.id] as form"
                            [formGroup]="form">
                    <mat-card-header>
                      <mat-card-title>
                        {{ environmentLabel(selected) }} credentials
                        <span class="active-badge" *ngIf="selected.id === activeConfigId">ACTIVE</span>
                      </mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                      <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
                        <mat-label>Base URL</mat-label>
                        <input matInput formControlName="baseUrl" />
                      </mat-form-field>

                      <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
                        <mat-label>Auth URL</mat-label>
                        <input matInput formControlName="authUrl" />
                      </mat-form-field>

                      <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
                        <mat-label>Client ID</mat-label>
                        <input matInput formControlName="clientId" />
                      </mat-form-field>

                      <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
                        <mat-label>Client secret</mat-label>
                        <input matInput type="password" formControlName="clientSecret"
                               [placeholder]="secretPlaceholder(selected)" />
                        <mat-hint>Leave blank to keep current</mat-hint>
                      </mat-form-field>

                      <mat-form-field appearance="outline" class="full-width" subscriptSizing="dynamic">
                        <mat-label>Merchant ID</mat-label>
                        <input matInput formControlName="merchantId" />
                      </mat-form-field>
                    </mat-card-content>
                    <mat-card-actions class="card-actions">
                      <button mat-stroked-button (click)="onSave(selected)">Save changes</button>
                      <button mat-stroked-button (click)="onTest(selected)">Test connection</button>
                      <button mat-flat-button color="primary" *ngIf="selected.id !== activeConfigId"
                              (click)="onSwitchLive(selected)">
                        Switch payments to {{ environmentLabel(selected) }}
                      </button>
                    </mat-card-actions>
                  </mat-card>

                </div>

                <div class="detail-col" *ngIf="selected.processor === 'CATALIS'">
                  <mat-card class="derived-card">
                    <mat-card-header>
                      <mat-card-title>Set automatically</mat-card-title>
                    </mat-card-header>
                    <mat-card-content>
                      <p class="derived-explainer">These are sent to Catalis. Nothing to fill in.</p>
                      <div class="derived-row">
                        <span class="derived-label">Taxpayer returns to</span>
                        <code class="derived-value">{{ selected.derivedReturnUrl }}</code>
                      </div>
                      <div class="derived-row">
                        <span class="derived-label">If they cancel</span>
                        <code class="derived-value">{{ selected.derivedBackUrl }}</code>
                      </div>
                      <div class="derived-row">
                        <span class="derived-label">Payment notifications</span>
                        <code class="derived-value" [class.derived-value--muted]="!selected.derivedCallbackUrl">{{ selected.derivedCallbackUrl || 'Not set — webhook disabled' }}</code>
                      </div>
                    </mat-card-content>
                  </mat-card>
                </div>

              </div>
            </ng-container>
          </ng-container>
        </ng-container>
      </div>
    </mat-tab>

    <mat-tab label="Communication log">
      <ng-template matTabContent>
        <div class="tab-body">
          <app-gateway-log-viewer></app-gateway-log-viewer>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>

</div>
